webpackJsonp([224878033341289],{

/***/ 1410:
/***/ (function(module, exports) {

	module.exports = {"data":{"allBlogJson":null,"authorJson":{"name":"Sanjala Chitnis","slug":"blog/author/sanjala-chitnis","twitter":"@sanjalachitnis","linkedIn":null,"website":null,"biography":"Sanjala is currently the Student Success Manager at Code Fellows and has a background in technical recruiting and university programs. She has a strong passion for diversity & inclusion, mental health advocacy, and employee engagement. #chipotle #beyonce","image":{"fields":{"description":"blog-author-sanjala-chitnis.jpg?1470337933","file":{"url":"//images.ctfassets.net/k428n7s2pxlu/5bC0RSC332QeWMcKwEeAik/d6d9e75669d61a4b0909408bbbc62aa3/blog-author-sanjala-chitnis.jpg_1470337933"}}}}},"pathContext":{"slug":"blog/author/sanjala-chitnis"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-author-sanjala-chitnis-f1e90e7de183f8ccde3c.js